export default class RewardUtils {
    public static GameRewards: any = {
        "0": 240,
        "1": 2100,
        "2": 2400,
        "3": 4400,
        "4": 4750
    }
}